var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstablishmentPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.65 392.65",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c02626"
    },
    d: "M343.585,30.604c-1.099-5.042-5.56-8.663-10.667-8.663H59.529c-5.107,0-9.632,3.62-10.667,8.663 L24.296,148.389h343.855L343.585,30.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M48.733,359.848c0,6.012,4.848,10.925,10.925,10.925h273.261c6.012,0,10.925-4.848,10.925-10.925 V170.175H48.733V359.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5be18e"
    },
    d: "M70.518,191.767v26.505h52.881c6.012,0,10.925,4.848,10.925,10.925s-4.848,10.925-10.925,10.925 H70.518v20.428h31.547c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H70.518v66.586h251.475V191.896 H70.518V191.767z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M182.357,292.551c0-4.59-3.685-8.275-8.275-8.275c-4.59,0-8.275,3.685-8.275,8.275 c0,13.899,9.438,25.665,22.174,29.285v6.335c0,4.59,3.685,8.275,8.275,8.275c4.59,0,8.275-3.685,8.275-8.275v-6.335 c12.735-3.62,22.174-15.386,22.174-29.285c0-16.873-14.869-30.384-31.612-30.384h-0.065c-7.111-0.646-12.671-6.594-12.671-13.834 c0-7.628,6.271-13.899,13.899-13.899c7.628,0,13.899,6.271,13.899,13.899c0,4.59,3.685,8.275,8.275,8.275s8.275-3.685,8.275-8.275 c0-13.899-9.438-25.665-22.174-29.285v-6.335c0-4.59-3.685-8.275-8.275-8.275s-8.275,3.685-8.275,8.275v6.335 c-12.735,3.62-22.174,15.386-22.174,29.285c0,16.873,13.705,30.448,30.448,30.448h0.065c7.111,0.646,13.834,6.465,13.834,13.77 c0,7.758-6.271,13.899-13.899,13.899C188.563,306.45,182.357,300.179,182.357,292.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M392.005,155.565L365.048,26.143C361.88,11.08,348.434,0.09,332.983,0.09H59.529 c-15.451,0-28.897,10.99-32.065,26.053L0.183,157.052c-1.228,7.046,3.879,13.123,10.667,13.123h15.968v189.673 c0,18.036,14.675,32.711,32.711,32.711h273.261c18.036,0,32.711-14.675,32.711-32.711V170.175h15.968h0.065 C388.062,170.886,394.785,163.517,392.005,155.565z M343.844,359.848h-0.065c0,6.012-4.849,10.925-10.925,10.925H59.593 c-6.012,0-10.925-4.848-10.925-10.925V170.175h295.111v189.673H343.844z M24.296,148.389L48.862,30.604 c1.034-5.042,5.495-8.663,10.667-8.663h273.455c5.107,0,9.632,3.62,10.667,8.663l24.566,117.786H24.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M93.985,97.06H74.074c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h19.911c6.012,0,10.925-4.848,10.925-10.925C104.91,101.909,100.062,97.06,93.985,97.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M168.781,97.06H148.87c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h19.911c6.012,0,10.925-4.848,10.925-10.925S174.858,97.06,168.781,97.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M243.642,97.06h-19.911c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h19.911c6.012,0,10.925-4.848,10.925-10.925C254.502,101.909,249.654,97.06,243.642,97.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M318.438,97.06h-19.976c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h19.911c6.012,0,10.925-4.848,10.925-10.925C329.298,101.909,324.45,97.06,318.438,97.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M142.276,62.345c0-6.012-4.848-10.925-10.925-10.925H111.44c-6.012,0-10.925,4.848-10.925,10.925 s4.848,10.925,10.925,10.925h19.911C137.428,73.27,142.276,68.422,142.276,62.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M217.137,62.345c0-6.012-4.848-10.925-10.925-10.925H186.3c-6.012,0-10.925,4.848-10.925,10.925 S180.224,73.27,186.3,73.27h19.911C212.223,73.27,217.137,68.422,217.137,62.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207e21"
    },
    d: "M291.933,62.345c0-6.012-4.848-10.925-10.925-10.925h-19.911c-6.012,0-10.925,4.848-10.925,10.925 s4.848,10.925,10.925,10.925h19.911C287.019,73.27,291.933,68.422,291.933,62.345z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstablishmentPay);
export default __webpack_public_path__ + "static/media/establishment-pay.eee483a31266b83f1dd9fd956d853a77.svg";
export { ForwardRef as ReactComponent };